import z from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { practiceIdSchema, practiceMemberIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { sessionIdSchema } from './ids';

// `signal-*` is the client asking to stop; the bare abort/finish below are the deferred work
// that carries it out. Distinct operations, not one operation on two transports.
export const RECORDING_SIGNAL_ABORT_TYPE = 'recording/signal-abort';
export const RECORDING_SIGNAL_FINISH_TYPE = 'recording/signal-finish';

const recordingIdOnly = z.object({
    recordingId: z.string().meta(metadata.nonSensitive),
});

export const recordingSignalAbort = defineCommand(RECORDING_SIGNAL_ABORT_TYPE, recordingIdOnly);

export const recordingSignalFinish = defineCommand(RECORDING_SIGNAL_FINISH_TYPE, recordingIdOnly);

export const RECORDING_CHUNK_TYPE = 'recording/chunk';

// The chunk arrives base64-encoded; the entrypoint decodes it to bytes.
export const recordingChunk = defineCommand(
    RECORDING_CHUNK_TYPE,
    z.object({
        recordingId: z.string(),
        chunk: z.string(),
        timestamp: z.number(),
    }),
);

export const RECORDING_ABORT_TYPE = 'recording/abort';
export const RECORDING_FINISH_TYPE = 'recording/finish';

export const recordingAbort = defineCommand(
    RECORDING_ABORT_TYPE,
    z.object({
        recordingId: z.string().meta(metadata.nonSensitive),
    }),
);

export const recordingFinish = defineCommand(
    RECORDING_FINISH_TYPE,
    z.object({
        recordingId: z.string().meta(metadata.nonSensitive),
    }),
);

export const RECORDING_START_TYPE = 'recording/start';

export const recordingStart = defineCommand(
    RECORDING_START_TYPE,
    z.object({
        target: z.literal('session').meta(metadata.nonSensitive),
        targetId: sessionIdSchema.meta(metadata.recordId),
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        practiceMemberId: practiceMemberIdSchema.meta(metadata.nonSensitive),
    }),
);
